if (!customElements.get('image-with-text-component')) {
  class ImageWithText extends HTMLElement {
    constructor() {
      super()
      this.collapsibleButtons = this.querySelectorAll('.collapsible-row__button')

      this.collapsibleRows = this.querySelectorAll('.collapsible-row__content')

      this._onClick = this.onCollapsibleRowClick.bind(this)
      this._onResize = this.renderCollapsibleRows.bind(this)
      this.addEventListener('click', this._onClick)
      window.addEventListener('resize', this._onResize)
      this.renderCollapsibleRows()
    }

    renderCollapsibleRows() {
      this.collapsibleRows.forEach((rowEl) => {
        const inner = rowEl.querySelector('.collapsible-row__content-inner')
        if (inner) {
          const innerHeight = `${inner.scrollHeight}px`
          rowEl.style.setProperty('--inner-height', innerHeight)
        }
      })
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick)
      window.removeEventListener('resize', this._onResize)
    }

    onCollapsibleRowClick(event) {
      if (event.target.classList.contains('collapsible-row__button')) {
        this.collapsibleButtons.forEach((el) => {
          if (el == event.target) {
            el.parentNode.classList.toggle('active')
          } else {
            el.parentNode.classList.remove('active')
          }
        })
      } else {
        return false
      }
    }
  }

  customElements.define('image-with-text-component', ImageWithText)
}
